import { css } from '@emotion/react';
import { SpacingToken } from '@livechat/design-system-react-components';
import { MEDIA_MIN_SM, MEDIA_MIN_XS } from '_assets/css/breakpoints';

export const container = css`
  display: flex;
  flex-direction: column;
  gap: var(${SpacingToken.Spacing3});
  padding: 0 var(${SpacingToken.Spacing5});
  margin-top: 56px;

  ${MEDIA_MIN_SM} {
    margin-top: 118px;
  }
`;

export const formField = css`
  width: 100%;
  margin-top: 16px;
  max-width: 360px;

  ${MEDIA_MIN_XS} {
    width: 360px;
  }
`;

export const button = css`
  width: 100%;
  margin-bottom: var(${SpacingToken.Spacing4});
  max-width: 360px;
`;
